/* tslint:disable */
/* eslint-disable */
/**
 * BFF Web Product
 * API reference used to call the backend from the web frontend
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateResourceRequest
 */
export interface CreateResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateResourceRequest
     */
    'productId'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateResourceRequest
     */
    'cohortIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateResourceRequest
     */
    'ownerId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateResourceRequest
     */
    'externalId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateResourceRequest
     */
    'type': CreateResourceRequestTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum CreateResourceRequestTypeEnum {
    SECTION = 'SECTION',
    GROUP = 'GROUP',
    EXTERNAL_MEMBER_AREA = 'EXTERNAL_MEMBER_AREA'
}


